import * as React from "react";
import PropTypes from 'prop-types';

const SvgSdpuTruck = props => {
  if (props.id !== "_svgsdputruck") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 21 20" fill="none" {...props}><path d="M18.38 9.94l-.77-.77a.195.195 0 01-.055-.084l-.845-2.5a.08.08 0 00-.09-.06h-1.915v-.46a.37.37 0 00-.24-.355.734.734 0 00-.18 0h-7a.33.33 0 00-.135.03l-.085.055a.335.335 0 00-.11.235l-.795 6.625v.035a.355.355 0 00.355.36H7.76a1.64 1.64 0 003.2.065h2.61c.035 0 .045 0 .05.045l.03.095a1.625 1.625 0 003.117-.106.065.065 0 01.041-.033.065.065 0 01.027-.001h1.3a.35.35 0 00.365-.36v-2.5a.375.375 0 00-.12-.315zm-3.675-2.72h1.415c.04 0 .06 0 .07.05.19.56.38 1.12.565 1.68v.06h-2.05V7.22zm-4.44 5.58a.88.88 0 110-.074v.075zm4.92.826a.905.905 0 01-.905-.9v-.075a.906.906 0 11.9 1l.005-.025zm-9.935-2.96H2.875a.375.375 0 000 .75H5.25a.375.375 0 000-.75zm0-1.75H3.5a.375.375 0 100 .75h1.75a.375.375 0 000-.75zm0-1.75H4a.375.375 0 100 .75h1.25a.375.375 0 000-.75z" fill="#202020" /></svg>;
};

SvgSdpuTruck.displayName = "_svgsdputruck";
SvgSdpuTruck.propTypes = {
  id: PropTypes.string
};
SvgSdpuTruck.defaultProps = {
  id: ''
};
export default SvgSdpuTruck;